import { render, staticRenderFns } from "./RcpIcon.vue?vue&type=template&id=36e79cee&"
import script from "./RcpIcon.vue?vue&type=script&lang=js&"
export * from "./RcpIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports